import { useState } from 'react';

import * as tracking from './tracking';
import { dispatchCustomEvent, useCustomEvent } from 'client-site-chrome-ui/hooks/useCustomEvent';
import type { Placement } from 'client-site-chrome-ui/types/locale';

const OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';

interface OpenModalCustomEventData {
  isOpen: boolean;
  placement: Placement;
}

export const useLocaleModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [triggeredFrom, setTriggeredFrom] = useState<Placement>('');

  /*
    handle updates using custom events to enable components rendered in different contexts to communicate.
    This is only need for the mononoth integration.
  */
  useCustomEvent(OPEN_MODAL_EVENT, (evt: Event) => {
    const data = (evt as CustomEvent).detail as OpenModalCustomEventData;
    setIsOpen(data.isOpen);
    setTriggeredFrom(data.placement);
  });

  return {
    isOpen,
    open: (placement: Placement) => {
      setTriggeredFrom(placement);
      tracking.sendToggleModalEvent(true, placement);
      dispatchCustomEvent(OPEN_MODAL_EVENT, { isOpen: true, placement });
    },
    close: () => {
      tracking.sendToggleModalEvent(false, triggeredFrom);
      dispatchCustomEvent(OPEN_MODAL_EVENT, { isOpen: false, placement: '' });
      setTriggeredFrom('');
    },
    closeAfterSave: () => {
      dispatchCustomEvent(OPEN_MODAL_EVENT, { isOpen: false, placement: '' });
    },
    placement: triggeredFrom,
  };
};
